import { gsap } from "gsap";

const fn = {
  init: () => {
    document.querySelectorAll(".element-leadincards .as-hover .block-item").forEach((el) => {
      const blockContent = el.querySelector(".block-content");

      el.addEventListener("pointerenter", () => {
        gsap.to(blockContent, {
          height: () => {
            return blockContent.scrollHeight;
          },
          opacity: 1,
          duration: 0.4,
          ease: "power2.out",
        });
      });

      el.addEventListener("pointerleave", () => {
        gsap.to(blockContent, {
          height: 0,
          opacity: 0,
          duration: 0.3,
          ease: "power2.out",
          onComplete: () => {
            blockContent.style.height = "0";
          },
        });
      });
    });

    if (document.querySelectorAll(".element-leadincards.as-only-image").length) {
      const resizeObserver = new ResizeObserver(() => {
        document.querySelectorAll(".element-leadincards.as-only-image .block-title").forEach((title) => {
          const span = title.querySelector("span");
          title.style.setProperty("--width", `${span.offsetWidth}px`);
        });
      });

      document.querySelectorAll(".element-leadincards.as-only-image .block-item").forEach((el) => {
        resizeObserver.observe(el);
      });
    }
  }
};

export default {
  can: () => document.querySelectorAll(".element-leadincards .as-hover .block-item").length,
  run: fn.init,
};

